import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Star, Loader2, Bus, UtensilsCrossed, LogOut, Edit, Info, X, CheckCircle, Clock, DollarSign, ShieldCheck, ShieldX, Phone, GraduationCap, MapPin, User, Calendar, Briefcase, IdCard, Check, FileText, Eye, Pencil } from "lucide-react";
import axios from "axios";
import banuser from "../assets/ban-user.svg";
import WorkerSummaryModal from "./workerSummaryModal";
import StarRatingInput from "./StarRatingInput"; 
import { SuccessModal, ErrorModal } from "./messagesModal";
import { useSuperAdmin } from "../context/SuperAdminContext";
import { useAuth } from "../context/auth-context";
import ReferenceDetails from "./WorkerReferenceDetails/ReferenceDetails";
import CompanyCheck from "./WorkerReferenceDetails/CompanyCheck";
import EShramSection from "./WorkerReferenceDetails/EShramSection";
import AadhaarDetailsModal from "./WorkerReferenceDetails/AdhaarDetailsModal";
import KycSection from "./WorkerReferenceDetails/KycSection";
import NameVerificationSection from "./WorkerReferenceDetails/NameVerificationSection";
import VerificationSection from "./WorkerReferenceDetails/VerificationSection";
import PaymentModeCard from "./PaymentModeCard";
import profileicon from "../assets/profile.png";
import ReferralPayoutModal from "../components/ReferralPayoutModal";
import AdminPaymentSetting from "../components/AdminPaymentSetting";
import summaryIcon from "../assets/summaryIcon.png";
import BlacklistStatus from "./WorkerReferenceDetails/BlacklistStatus";
import call from "../assets/call.png";
import education from "../assets/education.png";
import dob2 from "../assets/dob2.png";
import profile2 from "../assets/profile2.png";
import location from "../assets/location.png";
import skills2 from "../assets/skills2.png";
import uanIcon from "../assets/uan.png"; 
import preview from "../assets/preview.png";
import KYWform from "./KYWform";
import CallHistorySection from "./CallHistorySection.jsx"
import EditWorkerDetailModal from "./Editworkerdetailmodal.jsx";
import useDocumentPreview, { isImageUrl } from "../hooks/useDocumentPreview";

const ViewWorkerRating = () => {
  const { user } = useSuperAdmin();
  const { openDocumentPreview } = useDocumentPreview();
  const navigate = useNavigate();
  const [workerData, setWorkerData] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [workerCode, setworkerCode] = useState("");
  const [fullWorkerData, setFullWorkerData] = useState(null);
  const [showEshramTip, setShowEshramTip] = useState(false);
  const [takenApronDate, setTakenApronDate] = useState("");
  const [takenApron, setTakenApron] = useState(false);
  const [skills, setSkills] = useState([]);
  const [image, setImage] = useState(null);
  const [department, setDepartment] = useState("");
  const [totalShifts, setTotalShifts] = useState(0);
  const [totalHours, setTotalHours] = useState(0);
  const [totalGrossAmount, setTotalGrossAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipContent, setTooltipContent] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [isTooltipPinned, setIsTooltipPinned] = useState(false);
  const [deductionTooltip, setDeductionTooltip] = useState({
    visible: false,
    content: "",
    position: { x: 0, y: 0 },
  });
  const [activeBottomTab, setActiveBottomTab] = useState("attendance");
  const [activeTooltipId, setActiveTooltipId] = useState(null);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [showWorkerSummaryModal, setShowWorkerSummaryModal] = useState(false);
  const [isUTVMember, setIsUTVMember] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [highestQualification, setHighestQualification] = useState("");
  const [gender, setGender] = useState("");
  const [showchangepayoutmodal, setshowchangepayoutmodal] = useState(false);
  const [aadhaarDetails, setAadhaarDetails] = useState(null);
  const [showEditDetailsModal, setShowEditDetailsModal] = useState(false);
  
  // Store the actual worker ID from the API response
  const [actualWorkerId, setActualWorkerId] = useState(null);

  // Per-row submitting state for the inline star rating
  const [submittingRatingShiftId, setSubmittingRatingShiftId] = useState(null);

  const MIN_LOADING_TIME = 500;

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tooltipRef = useRef(null);
  const [featureAccess, setFeatureAccess] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [dob, setDob] = useState(null);
  const [address, setAddress] = useState(null);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [aadhaarPhoto, setAadhaarPhoto] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [isSubmittingDetails, setIsSubmittingDetails] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [activeSection, setActiveSection] = useState(null);
  const [showAadhaarModal, setShowAadhaarModal] = useState(false);
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [eligibleCompanyName, setEligibleCompanyName] = useState("");
  const [eligibleLocation, setEligibleLocation] = useState("");
  const [refCheck, setRefCheck] = useState(null);
  const [esharmData, setEsharmData] = useState(null);
  const [blacklistData, setBlacklistData] = useState(null);
  const [employers, setEmployers] = useState([]);
  const [isReferenceChecked, setIsReferenceChecked] = useState(false);
  const [isKycDone, setIsKycDone] = useState(false);
  const [nameVerificationStatus, setNameVerificationStatus] = useState(null);
  const [accountVerification, setAccountVerification] = useState(null);
  const [nameVerificationData, setNameVerificationData] = useState(null);
  const [verificationMeta, setVerificationMeta] = useState(null);
  const [workerRootMeta, setWorkerRootMeta] = useState(null);
  const [aadhaarName, setAadhaarName] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [ifsc, setIfsc] = useState(null);
  const [otherDocuments, setOtherDocuments] = useState([]);
  // Allotted accessories (logo, name, price) coming from worker-details response
  const [allottedAccessories, setAllottedAccessories] = useState([]);
  const [paymentmode, setpaymentmode] = useState("")

  const [attendancePage, setAttendancePage] = useState(1);
  const [hasMoreAttendance, setHasMoreAttendance] = useState(true);
  const [loadingMoreAttendance, setLoadingMoreAttendance] = useState(false);
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);
  const ATTENDANCE_PAGE_LIMIT = 10;

  const urlPath = window.location.pathname;
  const pathParts = urlPath.split("/");
  const userId = pathParts[pathParts.length - 1];

  const showDeductionTooltip = (e, text) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setDeductionTooltip({
      visible: true,
      content: text,
      position: { x: rect.left + rect.width / 2, y: rect.top - 8 },
    });
  };

  const hideDeductionTooltip = () => {
    setDeductionTooltip({ visible: false, content: "", position: { x: 0, y: 0 } });
  };

  // Fetch attendance records
  const fetchAttendanceRecords = useCallback(
    async (workerId, token, page = 1, append = false) => {
      const startTime = Date.now();
      
      try {
        if (append) setLoadingMoreAttendance(true);

        const response = await axios.post(
          `${BASE_URL}/lenskart-admin/worker-attendance-records`,
          {
            workerId: workerId,
            page,
            limit: ATTENDANCE_PAGE_LIMIT,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const elapsed = Date.now() - startTime;
        const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsed);
        
        if (remainingTime > 0) {
          await new Promise(resolve => setTimeout(resolve, remainingTime));
        }

        if (response.data.success) {
          const payload = response.data.data;
          const records = Array.isArray(payload) ? payload : payload?.records || [];
          const pagination = Array.isArray(payload) ? null : payload?.pagination;

          setWorkerData((prev) => (append ? [...(prev || []), ...records] : records));
          setAttendancePage(page);

          if (pagination) {
            setHasMoreAttendance(page < pagination.totalPages);
          } else {
            setHasMoreAttendance(records.length === ATTENDANCE_PAGE_LIMIT);
          }
        } else {
          console.warn("Attendance fetch returned success: false", response.data.message);
          if (!append) setWorkerData([]);
          setHasMoreAttendance(false);
        }
      } catch (error) {
        console.error("Error fetching attendance records:", error);
        if (!append) setWorkerData([]);
        setHasMoreAttendance(false);
      } finally {
        if (append) setLoadingMoreAttendance(false);
      }
    },
    [BASE_URL]
  );

  const loadMoreAttendance = useCallback(() => {
    const token = localStorage.getItem("superadmintoken");
    if (!token || !userId) return;
    if (loadingMoreAttendance || !hasMoreAttendance) return;
    
    const timeoutId = setTimeout(() => {
      fetchAttendanceRecords(userId, token, attendancePage + 1, true);
    }, 500); 
    
    return () => clearTimeout(timeoutId);
  }, [userId, attendancePage, hasMoreAttendance, loadingMoreAttendance, fetchAttendanceRecords]);

  const observerRef = useRef(null);
  const attendanceLoadMoreRef = useCallback(
    (node) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
      if (!node) return;

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            loadMoreAttendance();
          }
        },
        { root: null, rootMargin: "200px", threshold: 0 }
      );
      observerRef.current.observe(node);
    },
    [loadMoreAttendance]
  );

  // Effect to handle clicks outside the tooltip
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isTooltipPinned &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target)
      ) {
        setTooltipVisible(false);
        setTooltipContent(null);
        setActiveTooltipId(null);
        setIsTooltipPinned(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isTooltipPinned]);

  const handleBlacklistUpdate = (newIsBlacklisted, newCompanyName, newLocation) => {
    setIsBlacklisted(newIsBlacklisted);
    setEligibleCompanyName(newCompanyName || "");
    setEligibleLocation(newLocation || "");
  };

  const verifyTokenWithAuth = useCallback(
    async (authToken) => {
      try {
        const response = await axios.get(`${BASE_URL}/lenskart/verify-token`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        if (response.data?.error?.name === "TokenExpiredError") {
          localStorage.removeItem("superadmintoken");
          return false;
        }
        if (response.data?.success && response.data?.user) {
          const userData = response.data.user;
          setIsUTVMember(userData.UTVMember || false);
          setFeatureAccess(userData.featureAccess || []);
          setUserRole(userData.role || "");
        }
        return true;
      } catch (error) {
        console.error("Token verification failed:", error);
        localStorage.removeItem("superadmintoken");
        return false;
      }
    },
    [BASE_URL]
  );

  useEffect(() => {
    const checkTokenValidity = async () => {
      const token = localStorage.getItem("superadmintoken");
      if (!token) { navigate("/lkart/superadmin/"); return; }
      const isTokenValid = await verifyTokenWithAuth(token);
      if (!isTokenValid) navigate("/lkart/superadmin/");
    };
    checkTokenValidity();
  }, [navigate, verifyTokenWithAuth]);

  const fetchWorkerDetails = useCallback(async () => {
  try {
    const token = localStorage.getItem("superadmintoken");
    if (!token) { navigate("/lkart/superadmin/"); return; }

    const workerId = userId;
    const response = await axios.post(
      `${BASE_URL}/lenskart-admin/worker-details`,
      { workerId },
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );

    if (response.data.success) {
      const data = response.data.data;

      const verifiedWorkerId = data?.verification?.workerId || data?.verification?._id || null;
      if (verifiedWorkerId) setActualWorkerId(verifiedWorkerId);

      setFullWorkerData(data);
      setName(data.name);
      setPhone(data.phone);
      setworkerCode(data.workerCode);
      setImage(data.profilePhotoUrl);
      setTakenApronDate(data.takenApronDate || data.apronTakenDate);
      setTakenApron(data?.takenApron || false);
      setSkills(data?.skills || []);
      setDepartment(data.department);
      setTotalShifts(data?.totalShifts || 0);
      setTotalHours(data?.totalWorkingHours || 0);
      setDob(data?.dob || null);
      setAddress(data?.address || null);
      setHighestQualification(data?.highestQualification || "Not Available");
      setGender(data?.gender || "Not Available");

      // Allotted accessories (logo, name, price) from worker-details response
      setAllottedAccessories(data?.allottedAccessories || []);
      setpaymentmode(data?.payoutFrequency)
      
      // IMPORTANT: Extract from aadhaarDetails
      if (data.aadhaarDetails) {
        const aadhaar = data.aadhaarDetails;
        setIsAadhaarVerified(aadhaar.isAadhaarVerified || false);
        setAadhaarPhoto(aadhaar.aadhaarPhoto || null);
        setAadhaarName(aadhaar.aadhaarName || null);
        // Store the full aadhaar details for later use
        setAadhaarDetails(aadhaar);
      } else {
        // Fallback to old fields if aadhaarDetails doesn't exist
        setIsAadhaarVerified(data?.isAadhaarVerified || false);
        setAadhaarPhoto(data?.aadhaarPhoto || null);
        setAadhaarName(data?.aadhaarName || null);
      }
      
      setIsKycDone(data?.isKycDone || false);
      setOtherDocuments(data?.verification?.otherDocuments || []);

      setWorkerRootMeta({ aadhaarVerifiedBy: data?.aadhaarVerifiedBy || null });

      if (data.verification) {
        const v = data.verification;
        setRefCheck(v?.RefCheck || null);
        setEsharmData(v?.esharm || null);
        setBlacklistData(v?.blacklist || null);
        setEmployers(v?.Employers || []);
        setIsReferenceChecked(v?.RefCheck?.isReferenceChecked || false);
        setIsBlacklisted(v?.blacklist?.isBlacklisted || false);
        setNameVerificationStatus(v?.nameVerification?.status || null);
        setNameVerificationData(v?.nameVerification || null);
        setAccountNumber(data?.accountNumber || null);
        setIfsc(data?.IFSC || null);
        setAccountVerification(v?.accountVerification || null);

        if (v?.isKycDone) setIsKycDone(v.isKycDone.isDone === true);
        else setIsKycDone(data?.isKycDone || false);

        setVerificationMeta(v);
      }

      if (data.totalGrossAmount) setTotalGrossAmount(data.totalGrossAmount || 0);

      if (data.bankDetails) {
        setBankName(data.bankDetails.bankName || data.bankDetails.bank_name || null);
        setAccountNumber(data.bankDetails.accountNumber || null);
        setIfsc(data.bankDetails.IFSC || null);
        setBankDetails(data.bankDetails);
      }

      return true;
    } else {
      setError(response.data.message || "Failed to fetch worker data");
      return false;
    }
  } catch (err) {
    if (err.response?.status === 401) {
      localStorage.removeItem("superadmintoken");
      navigate("/lkart/superadmin/");
    } else {
      setError(err.response?.data?.message || "An error occurred while fetching data");
    }
    return false;
  }
}, [userId, navigate, BASE_URL]);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await fetchWorkerDetails();
      const token = localStorage.getItem("superadmintoken");
      if (token && userId) {
        await fetchAttendanceRecords(userId, token, 1, false);
      }
      setLoading(false);
    };
    if (userId) init();
  }, [userId, fetchWorkerDetails, fetchAttendanceRecords]);

  const handleDetailsSubmit = async (formDob, formAddress) => {
    setIsSubmittingDetails(true);
    try {
      const body = { dob: formDob, address: formAddress.trim(), workerId: userId };
      const token = localStorage.getItem("superadmintoken");
      const res = await fetch(`${BASE_URL}/lenskart-admin/update-worker-dob`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setDob(formDob);
        setAddress(formAddress.trim());
        setShowDetailsModal(false);
        setModalMessage("Worker details updated successfully!");
        setShowSuccessModal(true);
      } else {
        setShowDetailsModal(false);
        throw new Error(data.message || "Failed to update details");
      }
    } catch (error) {
      setModalMessage(error.message || "Failed to update details. Please try again.");
      setShowErrorModal(true);
    } finally {
      setIsSubmittingDetails(false);
    }
  };

  // Rating submission handler
  const handleRatingSubmit = async (reviewData, shiftId) => {
    setSubmittingRatingShiftId(shiftId);
    try {
      const record = workerData.find((r) => r.shiftId === shiftId);
      if (!record) throw new Error("Record not found");

      // Build comment array for ratings <= 3 stars
      let comment = [];
      if (reviewData.stars <= 3) {
        if (reviewData.discipline) comment.push({ Discipline: reviewData.discipline });
        if (reviewData.qualityOfWork) comment.push({ "Quality of Work": reviewData.qualityOfWork });
        if (reviewData.behaviour) comment.push({ Behaviour: reviewData.behaviour });
      }

      const requestData = {
        companyId: record.companyId,
        shiftId,
        stars: reviewData.stars,
        ...(comment.length > 0 && { comment }),
      };

      await axios.post(`${BASE_URL}/rating-lenskart/add`, requestData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("superadmintoken")}`,
        },
      });

      setWorkerData((prev) =>
        prev.map((r) =>
          r.shiftId === shiftId ? { ...r, rating: reviewData.stars, comment } : r
        )
      );
    } catch (error) {
      console.error("Error submitting review:", error);
    } finally {
      setSubmittingRatingShiftId(null);
    }
  };

  const formatDateToDisplay = (dateString) => {
    if (!dateString) return "";
    const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return "";
    const [_, year, month, day] = match;
    const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${parseInt(day)} ${monthNames[parseInt(month) - 1]} ${year}`;
  };

  const formatTimeToIST = (isoString) => {
    if (!isoString) return "-";
    const timeMatch = isoString.match(/T(\d{2}):(\d{2})/);
    if (!timeMatch) return "-";
    let hours = parseInt(timeMatch[1]);
    const minutes = timeMatch[2];
    const period = hours >= 12 ? "PM" : "AM";
    if (hours > 12) hours -= 12;
    else if (hours === 0) hours = 12;
    return `${hours}:${minutes} ${period}`;
  };

  const getPaymentStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "success": return "bg-green-100 text-green-800";
      case "pending": return "bg-yellow-100 text-yellow-800";
      case "payoutgenerated": return "bg-blue-100 text-blue-800";
      case "failed": return "bg-red-100 text-red-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };

  const hasFeatureAccess = (featureName) => {
    if (userRole === "super_admin") return true;
    if (userRole === "Admin") return featureAccess.includes(featureName);
    return false;
  };

  const renderStars = (rating) => {
    if (!rating) return null;
    return Array(5).fill(0).map((_, index) => (
      <Star
        key={index}
        className={`h-4 w-4 ${index < rating ? "text-yellow-400 fill-yellow-400" : "text-gray-300"}`}
      />
    ));
  };

  const showTooltip = (e, record, pin = false) => {
    if (!record.comment || record.comment.length === 0) return;
    const rect = e.target.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const tooltipWidth = 200;
    let x = rect.left + rect.width / 2;
    let y = rect.top - 10;
    if (x + tooltipWidth / 2 > viewportWidth - 20) x = viewportWidth - tooltipWidth / 2 - 20;
    if (x - tooltipWidth / 2 < 20) x = tooltipWidth / 2 + 20;
    if (y - 100 < 20) y = rect.bottom + 10;
    setTooltipPosition({ x, y });
    setTooltipContent(record.comment);
    setTooltipVisible(true);
    setIsTooltipPinned(pin);
    setActiveTooltipId(record.entryTime);
  };

  const hideTooltip = () => {
    if (!isTooltipPinned) {
      setTooltipVisible(false);
      setTooltipContent(null);
      setActiveTooltipId(null);
    }
  };

  const handlePhotoClick = (photoUrl) => {
    setSelectedPhoto(photoUrl);
    setShowPhotoModal(true);
  };

  const closePhotoModal = () => {
    setShowPhotoModal(false);
    setSelectedPhoto("");
  };

  const renderRatingWithTooltip = (record) => {
    if (!record.rating) return "-";
    return (
      <div className="flex items-center justify-center">
        <div className="flex mr-1">{renderStars(record.rating)}</div>
        {record.comment && record.comment.length > 0 && (
          <div
            className="ml-1 relative tooltip-trigger"
            onMouseEnter={(e) => {
              if (!isTooltipPinned || activeTooltipId !== record.entryTime)
                showTooltip(e, record, false);
            }}
            onMouseLeave={hideTooltip}
            onClick={(e) => {
              e.stopPropagation();
              if (activeTooltipId === record.entryTime && isTooltipPinned) {
                setTooltipVisible(false);
                setTooltipContent(null);
                setActiveTooltipId(null);
                setIsTooltipPinned(false);
              } else {
                showTooltip(e, record, true);
              }
            }}
          >
            <Info className={`h-4 w-4 cursor-pointer transition-colors ${activeTooltipId === record.entryTime && isTooltipPinned ? "text-blue-800" : "text-blue-600 hover:text-blue-800"}`} />
          </div>
        )}
      </div>
    );
  };

  // Rating column: shows stars with tooltip if rated, otherwise StarRatingInput
  const renderRatingColumn = (record) => {
    if (record.rating) return renderRatingWithTooltip(record);
    return (
      <div className="flex justify-center">
        <StarRatingInput
          shiftId={record.shiftId}
          onRate={(reviewData) => handleRatingSubmit(reviewData, record.shiftId)}
          isSubmitting={submittingRatingShiftId === record.shiftId}
        />
      </div>
    );
  };

  const getCompanyName = (record) => {
    const name = record.companyName || "Not Assigned";
    const code = record.companyCode;
    return code ? `${name} (${code})` : name;
  };

  const refMeta = verificationMeta?.RefCheck || {};
  const eshramMeta = verificationMeta?.esharm || {};
  const kycMeta = verificationMeta?.isKycDone || {};
  const nameVerificationMeta = verificationMeta?.nameVerification || {};
  const blacklistMeta = verificationMeta?.blacklist || {};

  const canEditVerification = hasFeatureAccess("Worker Verification");

  const sectionTitles = {
    company: "Company Check",
    reference: "Reference Check",
    eshram: "E-Shram Details",
    kyc: "KYC Status",
    bank: "Name Verification",
    aadhaar: "Aadhaar Details",
    blacklist: "Blacklist Status",
  };

  const handleEditSection = (section) => {
    if (section === 'aadhaar') {
      setShowAadhaarModal(true);
    } else {
      setActiveSection(section);
    }
  };

  const openBlobInNewTab = (blob) => {
  const blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
  // Keep the URL alive so the viewer's download button works
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 30 * 60 * 1000);
};

// Company of the most recent attendance entry (by entryTime), if any
const latestCompanyId = (() => {
  if (!Array.isArray(workerData) || workerData.length === 0) return null;
  const latest = workerData.reduce((a, b) =>
    new Date(b.entryTime) > new Date(a.entryTime) ? b : a
  );
  return latest?.companyId || null;
})();

  const handleProofOfWork = async () => {
    try {
      setIsLoadingReport(true);
      const token = localStorage.getItem("superadmintoken");
      if (!token) {
        console.error("No token found");
        return;
      }

      const workerIdToUse = actualWorkerId || userId;
      
      const response = await axios.get(
        `${BASE_URL}/lenskart/profile-report/${workerIdToUse}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: 'blob'
        }
      );

      const contentType = response.headers['content-type'] || '';
      
      if (contentType.includes('application/json')) {
  const reader = new FileReader();
  reader.onload = () => {
    try {
      const jsonData = JSON.parse(reader.result);

      if (jsonData.success && jsonData.data?.url) {
        // Already-hosted file case (kept for backward compatibility)
        window.open(jsonData.data.url, '_blank');
      } else if (jsonData.success && typeof jsonData.data === 'string') {
        // Base64-encoded file case (your actual response shape)
        const byteChars = atob(jsonData.data);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
          byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
       const mime = jsonData.mimeType || 'application/pdf';
const blob = new Blob([byteArray], { type: mime });

        if (mime.includes('pdf') || mime.includes('html')) {
  openBlobInNewTab(blob);
} else {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = jsonData.fileName || `worker_report_${workerIdToUse}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
}
      } else if (jsonData.success) {
        setModalMessage("Profile report generated successfully!");
        setShowSuccessModal(true);
      } else {
        throw new Error(jsonData.message || "Failed to generate profile report");
      }
    } catch (parseError) {
      console.error("Error parsing JSON:", parseError);
      setModalMessage("Unexpected response format");
      setShowErrorModal(true);
    }
  };
  reader.readAsText(response.data);
  return;
}

      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      
      if (contentType.includes('application/pdf') || contentType.includes('text/html')) {
        window.open(url, '_blank');
      } else {
        const link = document.createElement('a');
        link.href = url;
        const extension = contentType.includes('pdf') ? 'pdf' : 
                         contentType.includes('html') ? 'html' : 'bin';
        link.download = `worker_report_${workerIdToUse}.${extension}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
      
    } catch (error) {
      console.error("Error fetching profile report:", error);
      setModalMessage("Failed to generate profile report. Please try again.");
      setShowErrorModal(true);
    } finally {
      setIsLoadingReport(false);
    }
  };

  const handleEditPaymentMode = () => {
  setshowchangepayoutmodal(true);
  console.log("Edit Payment Mode");
};

  const handleIncentiveHistory = () => {
    console.log("Show Incentive History");
  };

  const handleReferralHistory = () => {
    setShowReferralModal(true);
  };

  const handlePayoutHistory = () => {
    console.log("Show Payout History");
  };

  const handlePaymentSchedule = () => {
  console.log("Show Payment Schedule");
};

  return (
    <div className="min-h-screen overflow-y-auto pt-16 bg-gray-50 px-2 py-4 sm:px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Worker Profile</h2>

        {loading ? (
          <div className="flex justify-center items-center p-8">
            <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
          </div>
        ) : error ? (
          <div className="text-center p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">{error}</div>
        ) : workerData ? (
          <>
            {/* TOP SECTION: TWO COLUMN CARDS */}
            <div className="flex flex-col lg:flex-row items-stretch gap-8 mb-6">

              {/* LEFT COLUMN SECTION (profile + stats) */}
              <div className="w-full lg:w-3/5 flex flex-col gap-6 min-w-0">

                {/* CARD 1: Profile Info */}
                <div className="bg-[#F6FBFF] rounded-2xl shadow-sm border border-gray-200 p-5 relative">
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-0">

                    {/* Left Half: Avatar + Basic Details */}
                    <div className="md:col-span-2 pr-4 flex flex-col min-w-0">
                      <div className="flex items-center gap-4 mb-5">
                        <div className="flex-shrink-0">
                          {image ? (
                            <img
                              src={image}
                              alt="Profile"
                              className="w-16 h-16 rounded-full object-cover border-2 border-green-500 cursor-pointer hover:opacity-80 transition-opacity"
                              onClick={() => handlePhotoClick(image)}
                            />
                          ) : (
                            <img
                              src={profileicon}
                              alt="Profile"
                              className="w-16 h-16 rounded-full object-cover border-2 border-gray-200"
                            />
                          )}
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center flex-wrap gap-2 mb-0.5">
                            <h3 className="text-lg font-bold text-gray-900 truncate">{name || "Worker"}</h3>
                            <button
                              type="button"
                              onClick={() => setShowEditDetailsModal(true)}
                              className="text-indigo-600 hover:text-indigo-600 transition-colors flex-shrink-0"
                              title="Edit Details"
                            >
                              <Pencil className="h-3.5 w-3.5" />
                            </button>
                          </div>
                          <p className="text-sm text-[#3b4a92] font-medium truncate">{workerCode || "Not Available"}</p>
                        </div>
                      </div>

                      {/* Contact & Personal Info Grid */}
                      <div className="grid grid-cols-2 gap-y-3 gap-x-2 text-sm text-[#3b4a92]">
                        <div className="flex items-center gap-2 min-w-0">
                          <img src={call} alt="Phone" className="h-4 w-4 flex-shrink-0" />
                          <span className="truncate">{phone || "Not Available"}</span>
                        </div>
                        <div className="flex items-center gap-2 min-w-0">
                          <img src={education} alt="Education" className="h-5 w-5 flex-shrink-0" />
                          <span className="truncate">{highestQualification || "Not Available"}</span>
                        </div>
                        <div className="flex items-center gap-2 min-w-0">
                          <img src={profile2} alt="Gender" className="h-4 w-4 flex-shrink-0" />
                          <span className="truncate">{gender || "Not Available"}</span>
                        </div>
                        <div className="flex items-center gap-2 min-w-0">
                          <img src={dob2} alt="Date of Birth" className="h-4 w-4 flex-shrink-0" />
                          <span className="truncate">{dob ? formatDateToDisplay(dob) : "Not Available"}</span>
                        </div>
                      </div>
                    </div>

                    {/* Right Half: UAN, Address, Skills */}
                    <div className="md:col-span-3 pl-0 md:pl-6 flex flex-col justify-center space-y-4 text-[#3b4a92] border-t md:border-t-0 md:border-l border-gray-300 pt-4 md:pt-0 min-w-0">
  <div className="flex items-start gap-3 min-w-0">
    {/* UAN Icon with #3F5389 color */}
    <img 
      src={uanIcon} 
      alt="UAN" 
      className="h-5 w-5 flex-shrink-0 mt-0.5" 
      style={{ color: '#3F5389' }}
    />
    <div className="w-full min-w-0">
      <p className="text-xs font-medium text-[#7a88b8]">UAN Number</p>
      <div
        className="relative flex items-center gap-2 w-fit"
        onMouseEnter={() => esharmData?.UAN && setShowEshramTip(true)}
        onMouseLeave={() => setShowEshramTip(false)}
      >
        <p className="text-sm font-medium text-gray-800 break-all">
          {esharmData?.UAN || "-"}
        </p>
        
        {/* Preview icon - shows when document is uploaded */}
        {esharmData?.url && (
  <img
    src={preview}
    alt="Preview Document"
    className="h-4 w-4 object-contain cursor-pointer hover:opacity-70 transition-opacity"
    onClick={(e) => {
      e.stopPropagation();
      openDocumentPreview(esharmData.url);
    }}
    title="Preview E-Shram Document"
  />
)}
        
        {canEditVerification && (
          <Pencil
            className="h-3.5 w-3.5 text-indigo-500 cursor-pointer hover:text-indigo-700 flex-shrink-0"
            onClick={() => setActiveSection('eshram')}
          />
        )}

        {esharmData?.UAN && showEshramTip && (
          <div className="absolute left-0 bottom-full mb-2 z-50 w-64 rounded-lg border border-gray-200 bg-white p-3 shadow-lg">
            <div className="flex justify-between gap-2 text-[11px] py-0.5">
              <span className="text-gray-400 font-medium whitespace-nowrap">Done By</span>
              <span className="text-gray-700 font-medium text-right break-words">
                {esharmData?.doneByName || "-"}
              </span>
            </div>
            <div className="flex justify-between gap-2 text-[11px] py-0.5">
              <span className="text-gray-400 font-medium whitespace-nowrap">Done At</span>
              <span className="text-gray-700 font-medium text-right break-words">
                {formatDateToDisplay(esharmData?.doneAt) || "-"}
              </span>
            </div>
            {esharmData?.url && (
              <>
                <div className="border-t border-gray-200 mt-1 pt-1">
                  <div className="flex justify-between gap-2 text-[11px] py-0.5">
                    <span className="text-gray-400 font-medium whitespace-nowrap">Document</span>
                    <span className="text-green-600 font-medium text-right">
                      Uploaded ✓
                    </span>
                  </div>
                  {esharmData?.uploadedAt && (
                    <div className="flex justify-between gap-2 text-[11px] py-0.5">
                      <span className="text-gray-400 font-medium whitespace-nowrap">Uploaded At</span>
                      <span className="text-gray-700 font-medium text-right break-words">
                        {formatDateToDisplay(esharmData?.uploadedAt) || "-"}
                      </span>
                    </div>
                  )}
                  {esharmData?.uploadedByName && (
                    <div className="flex justify-between gap-2 text-[11px] py-0.5">
                      <span className="text-gray-400 font-medium whitespace-nowrap">Uploaded By</span>
                      <span className="text-gray-700 font-medium text-right break-words">
                        {esharmData?.uploadedByName || "-"}
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}
            <div className="absolute left-4 top-full w-2 h-2 -mt-1 rotate-45 bg-white border-r border-b border-gray-200" />
          </div>
        )}
      </div>
    </div>
  </div>
  {/* Address section */}
  <div className="flex items-start gap-3 min-w-0">
    <img src={location} alt="Location" className="h-5 w-5 flex-shrink-0 mt-0.5" />
    <div className="w-full min-w-0">
      <p className="text-xs font-medium text-[#7a88b8]">Address</p>
      <p className="text-sm font-medium text-gray-800 break-words whitespace-normal leading-snug">
        {address || "Not Available"}
      </p>
    </div>
  </div>
  {/* Skills section */}
  <div className="flex items-start gap-3 min-w-0">
    <img src={skills2} alt="Skills" className="h-5 w-5 flex-shrink-0 mt-0.5" />
    <div className="w-full min-w-0">
      <p className="text-xs font-medium text-[#7a88b8]">Skills</p>
      <p className="text-sm font-medium text-gray-800 break-words whitespace-normal leading-snug">
        {skills && skills.length > 0 ? skills.join(", ") : "Not Available"}
      </p>
    </div>
  </div>
</div>
                  </div>
                </div>

                {/* CARD 2: Stats & Payment Mode Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                  {/* Stats Card */}
                  <div className="bg-[#F6FBFF] rounded-2xl shadow-sm border border-gray-200 p-5 flex items-center justify-between gap-3 min-w-0">
                    <div className="flex gap-5 min-w-0">
                      <div className="flex flex-col gap-1 min-w-0">
                        <span className="text-[11px] text-gray-500 font-medium whitespace-nowrap">Shifts Hours</span>
                        <span className="text-base font-bold text-[#101d75] truncate">{totalHours.toFixed(2)}</span>
                      </div>
                      <div className="flex flex-col gap-1 border-l border-gray-300 pl-5 min-w-0">
                        <span className="text-[11px] text-gray-500 font-medium whitespace-nowrap">Total Shifts</span>
                        <span className="text-base font-bold text-[#101d75] truncate">{totalShifts}</span>
                      </div>
                      <div className="flex flex-col gap-1 border-l border-gray-300 pl-5 min-w-0">
                        <span className="text-[11px] text-gray-500 font-medium whitespace-nowrap">Earnings</span>
                        <div className="flex items-center gap-1 text-base font-bold text-[#101d75] truncate">
                          ₹{totalGrossAmount}
                        </div>
                      </div>
                    </div>
                    <div
                      className="pl-4 text-[#101d75] cursor-pointer hover:text-white flex-shrink-0"
                      onClick={() => setShowWorkerSummaryModal(true)}
                    >
                      <img src={summaryIcon} className="h-6 w-6" />
                    </div>
                  </div>

                  {/* Payment Mode Card */}
                  <PaymentModeCard
  workerId={userId}
  paymentMode={paymentmode}
  onEditPaymentMode={handleEditPaymentMode}
  onIncentiveHistory={handleIncentiveHistory}
  onReferralHistory={handleReferralHistory}
  onPayoutHistory={handlePayoutHistory}
  onSchedule={handlePaymentSchedule}
/>

                </div>
              </div>

              {/* RIGHT COLUMN SECTION (verification) */}
              <div className="w-full lg:w-2/5 flex flex-col gap-6 min-w-0">
                <VerificationSection
  verificationData={{
    isAadhaarVerified: aadhaarDetails?.isAadhaarVerified || false,
    aadhaarVerifiedByName: aadhaarDetails?.aadhaarVerifiedBy || workerRootMeta?.aadhaarVerifiedBy || null,
    aadhaarVerifiedAt: aadhaarDetails?.aadhaarVerifiedOn || null,
    employers,
    isReferenceChecked,
    isKycDone,
    esharmData,
    takenApron,
    takenApronDate,
    bankName: bankName || 'Not Available',
    accountNumber,
    IFSC: ifsc,
    bankDetails: bankDetails,
    workerId: userId,
    workerName:name,
    workerCode:workerCode,
    verification: fullWorkerData?.verification || {},
    otherDocuments: otherDocuments,
    // Allotted accessories (logo, name, price) fetched from worker-details endpoint
    allottedAccessories: allottedAccessories,
    isBlacklisted,
    eligibleCompanyName,
    eligibleLocation,
    blacklistReason: blacklistData?.reason || blacklistData?.blacklistReason || "",
    blacklistMarkedByName: blacklistMeta.markedByName || blacklistMeta.doneByName || null,
    blacklistMarkedAt: blacklistMeta.markedAt || blacklistMeta.doneAt || null,
  }}
  canEditVerification={canEditVerification}
  onEditSection={handleEditSection}
  onShowProofOfWork={handleProofOfWork}
  isLoadingReport={isLoadingReport}
  onRefresh={fetchWorkerDetails}
/>
              </div>
            </div>

            {/* BOTTOM SECTION: ATTENDANCE HISTORY */}
                         {/* BOTTOM SECTION: TABS */}
            <div className="mt-6">
              <div className="flex items-center gap-10 mb-4 border-b border-gray-200">
                <button
                  type="button"
                  onClick={() => setActiveBottomTab("attendance")}
                  className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                    activeBottomTab === "attendance"
                      ? "border-gray-800 text-gray-800 font-bold"
                      : "border-transparent text-gray-400 hover:text-gray-400"
                  }`}
                >
                  Attendance History
                </button>
                                <button
                  type="button"
                  onClick={() => setActiveBottomTab("Callhistory")}
                  className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                    activeBottomTab === "Callhistory"
                      ? "border-gray-800 text-gray-800 font-bold"
                      : "border-transparent text-gray-400 hover:text-gray-400"
                  }`}
                >
                 Call History
                </button>
                <button
                  type="button"
                  onClick={() => setActiveBottomTab("kyc")}
                  className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                    activeBottomTab === "kyc"
                      ? "border-gray-800 text-gray-800 font-bold"
                      : "border-transparent text-gray-400 hover:text-gray-400"
                  }`}
                >
                  Know Your Worker
                </button>
              </div>

              {activeBottomTab === "attendance" && (
                <>
                  {workerData.length > 0 ? (
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border-collapse">
                      <thead>
                        <tr className="bg-[#F6FBFF] border-b border-gray-200">
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Entry Date &amp; Time</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Exit Date &amp; Time</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Company</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Department</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Working Hours</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Payment</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Payment Mode</th>
                          <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">To be paid on</th>
                          {hasFeatureAccess("Add Rating") && (
                            <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Rating</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {workerData.map((record, index) => (
                          <tr key={index} className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors">
                            <td className="p-3 align-middle">
                              <div className="flex items-center justify-center gap-2">
                                <div className="flex flex-col">
                                  <span className="font-medium text-gray-800 text-sm">
                                    {formatDateToDisplay(record.entryTime)}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    {formatTimeToIST(record.entryTime)}
                                  </span>
                                </div>
                                {record.busEntry && (
                                  <Bus
                                    className="h-4 w-4 text-[#3D5A80] cursor-pointer"
                                    onMouseEnter={(e) =>
                                      showDeductionTooltip(e, `Bus Entry Deduction: ₹${record.busEntryDeduction || 0}`)
                                    }
                                    onMouseLeave={hideDeductionTooltip}
                                  />
                                )}
                              </div>
                            </td>
                            <td className="p-3 align-middle">
                              <div className="flex items-center justify-center gap-2">
                                <div className="flex flex-col">
                                  <span className="font-medium text-gray-800 text-sm">
                                    {record.exitTime ? formatDateToDisplay(record.exitTime) : "-"}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    {record.exitTime ? formatTimeToIST(record.exitTime) : "-"}
                                  </span>
                                </div>
                                {record.exitTime && record.busExit && (
                                  <Bus
                                    className="h-4 w-4 text-[#3D5A80] cursor-pointer"
                                    onMouseEnter={(e) =>
                                      showDeductionTooltip(e, `Bus Exit Deduction: ₹${record.busExitDeduction || 0}`)
                                    }
                                    onMouseLeave={hideDeductionTooltip}
                                  />
                                )}
                                {record.hadFood && (
                                  <UtensilsCrossed
                                    className="h-4 w-4 text-[#F4A261] cursor-pointer"
                                    onMouseEnter={(e) =>
                                      showDeductionTooltip(e, `Food Deduction: ₹${record.foodDeduction || 0}`)
                                    }
                                    onMouseLeave={hideDeductionTooltip}
                                  />
                                )}
                              </div>
                            </td>
                            <td className="p-3 align-middle">
                              <span className="text-sm text-gray-700 font-medium">
                                {record.companyName || "Not Assigned"}
                                {record.companyCode && (
                                  <span className="text-xs text-gray-700 font-normal ml-1">
                                    ({record.companyCode})
                                  </span>
                                )}
                              </span>
                            </td>
                            <td className="p-3 align-middle">
                              <span className="text-sm text-gray-600">
                                {record.department || "-"}
                              </span>
                            </td>
                            <td className="p-3 align-middle">
                              <span className="text-sm text-gray-700">
                                {record.exitTime ? `${record.workingHours?.toFixed(2)} hrs` : "-"}
                              </span>
                            </td>
                            <td className="p-3 align-middle">
                              <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${getPaymentStatusColor(record.status)}`}>
                                ₹{record.netAmount ? record.netAmount : 0}
                              </span>
                            </td>
                            <td className="p-3 align-middle">
                              <span className="text-xs text-gray-600">
                               {record.payoutFrequency ? record.payoutFrequency : "-"}
                              </span>
                            </td>
                            <td className="p-3 align-middle">
                              <span className="text-xs text-gray-600">
                                {record.eligible_date_for_payment ? formatDateToDisplay(record.eligible_date_for_payment) : "-"}
                              </span>
                            </td>
                            {hasFeatureAccess("Add Rating") && (
                              <td className="p-3 align-middle">
                                {renderRatingColumn(record)}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Infinite scroll sentinel */}
                  {hasMoreAttendance && (
                    <div ref={attendanceLoadMoreRef} className="flex justify-center items-center py-4">
                      {loadingMoreAttendance ? (
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                          <Loader2 className="h-4 w-4 animate-spin text-indigo-600" />
                          Loading more...
                        </div>
                      ) : (
                        <div className="h-4" />
                      )}
                    </div>
                  )}

                  {!hasMoreAttendance && workerData.length > 0 && (
                    <div className="text-center py-3 text-xs text-gray-400">
                      No more records
                    </div>
                  )}
                </div>
                  ) : (
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center text-gray-500">No attendance records found</div>
                  )}
                </>
              )}

              {/* {activeBottomTab === "kyc" && (
                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
                  <KycSection
                    workerId={userId}
                    initialIsKycDone={isKycDone}
                    onKycUpdate={(newState) => setIsKycDone(newState)}
                    kycDoneByName={kycMeta.doneByName || null}
                    kycDoneAt={kycMeta.doneAt || null}
                  />
                </div>
              )} */}
            </div>
          </>
        ) : (
          <div className="text-center p-8 bg-white rounded-xl shadow-sm text-gray-500">Worker not found</div>
        )}

        {/* Photo Modal */}
        {showPhotoModal && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[1000] p-4">
            <div className="relative max-w-md">
              <button onClick={closePhotoModal} className="absolute -top-4 -right-4 bg-white rounded-full p-2 hover:bg-gray-100 z-10 shadow-lg">
                <X size={24} className="text-gray-600" />
              </button>
              <img src={selectedPhoto} alt="Profile" className="w-full h-auto rounded-lg max-h-[80vh] object-contain" />
            </div>
          </div>
        )}

        {/* Tooltip */}
        {tooltipVisible && tooltipContent && (
          <div
            ref={tooltipRef}
            className={`fixed z-[9999] p-3 text-xs bg-white shadow-xl rounded-lg border border-gray-200 transition-opacity duration-200 ${isTooltipPinned ? "pointer-events-auto" : "pointer-events-none"}`}
            style={{
              left: tooltipPosition.x,
              top: tooltipPosition.y,
              transform: tooltipPosition.y > window.innerHeight / 2 ? "translate(-50%, -100%)" : "translate(-50%, 10px)",
              width: "max-content",
              maxWidth: Math.min(200, window.innerWidth - 40) + "px",
            }}
          >
            <div className="break-words">
              {tooltipContent.map((item, index) => (
                <div key={index} className="text-gray-600 mb-1">
                  {Object.entries(item).map(([key, value]) => (
                    <div key={key}><span className="font-semibold">{key}:</span> {value}</div>
                  ))}
                </div>
              ))}
            </div>
            <div className={`absolute left-1/2 transform -translate-x-1/2 border-4 border-transparent ${tooltipPosition.y > window.innerHeight / 2 ? "top-full border-t-white" : "bottom-full border-b-white"}`} />
          </div>
        )}

        {deductionTooltip.visible && (
          <div
            className="fixed z-[9999] p-2 text-xs bg-gray-800 text-white rounded-md shadow-lg pointer-events-none whitespace-nowrap"
            style={{
              left: deductionTooltip.position.x,
              top: deductionTooltip.position.y,
              transform: "translate(-50%, -100%)",
            }}
          >
            {deductionTooltip.content}
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
          </div>
        )}

        {/* Details Modal */}
        {showDetailsModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Add Worker Aadhar Details</h3>
                <button onClick={() => setShowDetailsModal(false)} className="text-gray-500 hover:text-gray-700" disabled={isSubmittingDetails}>
                  <X size={24} />
                </button>
              </div>
              <form onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                const formDob = formData.get("dob");
                const formAddress = formData.get("address");
                if (!formDob || !formAddress.trim()) {
                  setModalMessage("Please fill in all fields");
                  setShowErrorModal(true);
                  return;
                }
                handleDetailsSubmit(formDob, formAddress);
              }}>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
                    <input type="date" name="dob" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" disabled={isSubmittingDetails} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                    <textarea name="address" required rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Enter full address" disabled={isSubmittingDetails} />
                  </div>
                </div>
                <div className="flex justify-end gap-3 mt-6">
                  <button type="button" onClick={() => setShowDetailsModal(false)} className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors" disabled={isSubmittingDetails}>Cancel</button>
                  <button type="submit" disabled={isSubmittingDetails} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center transition-colors">
                    {isSubmittingDetails ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Submitting...</> : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        <SuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} message={modalMessage} />
        <ErrorModal isOpen={showErrorModal} onClose={() => setShowErrorModal(false)} message={modalMessage} />

        <WorkerSummaryModal
          isOpen={showWorkerSummaryModal}
          onClose={() => setShowWorkerSummaryModal(false)}
          workerId={userId}
          isUTVMember={isUTVMember}
        />

        <AadhaarDetailsModal
  isOpen={showAadhaarModal}
  onClose={() => setShowAadhaarModal(false)}
  workerId={userId}
  onSuccess={(newDob, newAddress, newAadhaarName) => {
    setDob(newDob);
    setAddress(newAddress);
    setIsAadhaarVerified(true);
    if (newAadhaarName) setAadhaarName(newAadhaarName);
  }}
  initialDob={dob}
  initialAddress={address}
  aadhaarPhoto={aadhaarPhoto}
  aadharverified={isAadhaarVerified}
  aadhaarName={aadhaarName}
  aadhaarNumber={aadhaarDetails?.aadhaarNo || null}
  aadhaarVerifiedBy={aadhaarDetails?.aadhaarVerifiedBy || null}
  aadhaarVerifiedOn={aadhaarDetails?.aadhaarVerifiedOn || null}
  aadhaarDOB={aadhaarDetails?.aadhaarDOB || null}
  isAlreadyVerified={aadhaarDetails?.isAadhaarVerified || false}
  canEditVerification={canEditVerification}
/>

        {activeSection && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1100] p-3">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[92vh] flex flex-col">
              <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 flex-shrink-0">
                <div>
                  <h2 className="text-base font-bold text-gray-800">{sectionTitles[activeSection]}</h2>
                </div>
                <button onClick={() => {
    setActiveSection(null);
    fetchWorkerDetails();
  }} className="text-gray-400 hover:text-gray-600 transition">
                  <X size={20} />
                </button>
              </div>

              <div className="overflow-y-auto flex-1 px-5 py-5">
                {activeSection === "company" && (
  <CompanyCheck
    workerId={userId}
    isUTVMember={isUTVMember}
    onClose={() => setActiveSection(null)}
    initialEmployers={employers}
    canEditVerification={canEditVerification}
  />
)}
{activeSection === "reference" && (
  <ReferenceDetails
    workerId={userId}
    onClose={() => setActiveSection(null)}
    initialData={refCheck}
    isRefChecked={isReferenceChecked}
    doneByName={refMeta.doneByName}
    doneAt={refMeta.doneAt}
    canEditVerification={canEditVerification}
  />
)}
                {activeSection === "eshram" && (
  <EShramSection
    workerId={userId}
    isRefChecked={isReferenceChecked}
    initialEsharmId={esharmData?.UAN || null}
    doneByName={eshramMeta.doneByName}
    doneAt={eshramMeta.doneAt}
    // Document props from esharm data
    initialDocumentUrl={esharmData?.url || null}
    initialDocumentMeta={{
      uploadedAt: esharmData?.uploadedAt || null,
      uploadedBy: esharmData?.uploadedBy || null,
      uploadedByName: esharmData?.uploadedByName || null,
    }}
    onRefresh={fetchWorkerDetails}
  />
)}
                {/* {activeSection === "kyc" && (
                  <KycSection
                    workerId={userId}
                    initialIsKycDone={isKycDone}
                    onKycUpdate={(newState) => setIsKycDone(newState)}
                    kycDoneByName={kycMeta.doneByName || null}
                    kycDoneAt={kycMeta.doneAt || null}
                  />
                )} */}
                {activeSection === "bank" && (
<NameVerificationSection
  workerId={userId}
  initialCompanyId={latestCompanyId}
  initialStatus={nameVerificationMeta?.status || null}
  doneByName={nameVerificationMeta?.doneByName || null}
  doneAt={nameVerificationMeta?.doneAt || null}
  workerName={name || null}
  aadhaarName={aadhaarName || null}
  bankName={bankName || null}
  initialAadhaarNameMatched={
    nameVerificationMeta?.aadhaarNameMatched || false
  }
  initialIsBankNameException={
    nameVerificationMeta?.isBankNameException || false
  }
  initialBankExceptionReason={
    nameVerificationMeta?.bankExceptionReason || null
  }
  initialIsOverAgeException={
    nameVerificationMeta?.isOverAgeException || false
  }
  initialOverAgeExceptionReason={
    nameVerificationMeta?.overAgeExceptionReason || null
  }
  initialIsRefCheckException={
    nameVerificationMeta?.isRefCheckException || false
  }
  initialRefCheckExceptionReason={
    nameVerificationMeta?.refCheckExceptionReason || null
  }
  initialRejectionReason={
    nameVerificationMeta?.rejectionReason || null
  }
/>

                )}

                <div className="overflow-y-auto flex-1 px-5 py-5">
                  {activeSection === "blacklist" && (
                    <div className="w-full">
                      <BlacklistStatus
                        workerId={userId}
                        workerName={name}
                        isUTVMember={isUTVMember}
                        initialIsBlacklisted={isBlacklisted}
                        initialEligibleCompanyName={eligibleCompanyName}
                        initialEligibleLocation={eligibleLocation}
                        initialReason={blacklistData?.reason || blacklistData?.blacklistReason || ""}
                        onUpdate={handleBlacklistUpdate}
                        markedByName={blacklistMeta.markedByName || blacklistMeta.doneByName}
                        markedAt={blacklistMeta.markedAt || blacklistMeta.doneAt}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-end px-5 py-3 border-t border-gray-200 flex-shrink-0 bg-gray-50 rounded-b-xl">
                <button
                  type="button"
                  
                  onClick={() => {
    setActiveSection(null);
  fetchWorkerDetails();
  }}
                  className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100 transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Referral Payout Modal */}
        <ReferralPayoutModal
          isOpen={showReferralModal}
          onClose={() => setShowReferralModal(false)}
          workerId={actualWorkerId || userId}
        />

        <AdminPaymentSetting
  isOpen={showchangepayoutmodal}
  onClose={() => setshowchangepayoutmodal(false)}
  workerId={actualWorkerId || userId}
  fetchWorkerDetails={fetchWorkerDetails}
/>

        {/* Edit Details Modal — Name, Gender, Location, Skills, Education */}
        <EditWorkerDetailModal
          isOpen={showEditDetailsModal}
          onClose={() => setShowEditDetailsModal(false)}
          token={localStorage.getItem("superadmintoken")}
          workerId={actualWorkerId || userId}
          initialData={{
            name,
            gender,
            highestQualification,
            skillIds: fullWorkerData?.skillIds || [],
            preferredLocationId: fullWorkerData?.preferredLocationId,
            preferredLocation: fullWorkerData?.preferredLocation,
            RelativeName:fullWorkerData?.verification?.RefCheck?.RelativeName,
            RelativePhone:fullWorkerData?.verification?.RefCheck?.RelativePhone,
            RelativeType:fullWorkerData?.verification?.RefCheck?.RelativeType,
            temporaryAddress:fullWorkerData?.temporaryAddress
          }}
          saveUrl={`${BASE_URL}/lenskart/save-data`}
          onSaved={() => {
            fetchWorkerDetails();
          }}
        />


{activeBottomTab === "kyc" && (
  <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
    <KYWform workerId={userId}
    onRefresh={fetchWorkerDetails}
    />
  </div>
)}


{activeBottomTab === "Callhistory" && (
  <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
    <CallHistorySection
      worker={fullWorkerData}
    />
  </div>
)}
      </div>
    </div>
  );
};

export default ViewWorkerRating;